export default {
    'de': '🇩🇪',
    'en': '🇺🇸'
};
